import './styles/base-styles.scss';
import React from 'react';
import WwhRoutes from './app/routes';

function App  () {
    return (
        <div>
            <WwhRoutes />
        </div>

        // <div class="alert alert-primary" role="alert">
        //     <div class="middle deere-yellow">
        //         <p>The new WWH portal will be operational by <font color="#fffaf0"><b><i><u>21st November 2023</u></i></b></font></p>
        //     </div>
        // </div>
    );
}

export default App;